(() => {
  const productForm = document.querySelector(
    ".shopify-section-main-product product-form"
  );
  if (!productForm) return;

  const variantSelect = productForm.querySelector('select[name="id"]');
  const rewardsHome = productForm.querySelector('.swt-header-label--specs');
  const rewardsDestination = productForm.querySelector('[data-pdp-compact-rewards]');
  const rewards = rewardsHome?.querySelector('.product-points-item');
  if (rewards && rewardsDestination) {
    const compactViewport = window.matchMedia('(max-width: 375.98px)');
    const placeRewards = () => {
      if (compactViewport.matches) {
        rewardsDestination.appendChild(rewards);
      } else {
        rewardsHome.insertBefore(rewards, rewardsHome.querySelector('.pdp-breaker-spec-line'));
      }
    };
    compactViewport.addEventListener('change', placeRewards);
    placeRewards();
  }

  const selectedVariant = () => {
    if (Object.prototype.hasOwnProperty.call(productForm, "currentVariant")) {
      return productForm.currentVariant || null;
    }
    const variants = window.theme?.product?.variants || [];
    const selectedId = String(variantSelect?.value || "");
    return variants.find((variant) => String(variant.id) === selectedId) || null;
  };

  const warrantyIsEligible = (variant) => {
    if (!variantSelect || !variant) return false;
    return [...variantSelect.options].some(
      (option) =>
        String(option.value) === String(variant.id) &&
        option.dataset.warrantyEligible === "true"
    );
  };

  const isRecertified = (variant) => {
    if (!variant) return false;
    return (
      (variant.options || []).includes("Re-Certified") ||
      String(variant.sku || "").toUpperCase().endsWith("-R")
    );
  };

  const displaySku = (variant) =>
    String(variant?.sku || "").replace(/-R$/i, "");

  const sync = () => {
    const variant = selectedVariant();

    const eligible = warrantyIsEligible(variant);
    document.querySelectorAll('[data-pdp-warranty-copy="eligible"]').forEach((copy) => {
      copy.hidden = !eligible;
    });
    document.querySelectorAll('[data-pdp-warranty-copy="standard"]').forEach((copy) => {
      copy.hidden = eligible;
    });
    document.querySelectorAll("[data-pdp-warranty-upsell]").forEach((upsell) => {
      upsell.hidden = !eligible;
    });

    const recertified = isRecertified(variant);
    document.querySelectorAll("[data-pdp-product-type]").forEach((type) => {
      const baseType = type.dataset.baseProductType || "";
      type.textContent = baseType;
      if (recertified) {
        // The span keeps the hyphenated word on one line.
        const condition = document.createElement("span");
        condition.className = "pdp-heading-condition";
        condition.textContent = "(Re-Certified)";
        type.appendChild(document.createTextNode(" "));
        type.appendChild(condition);
      }
    });
    document.querySelectorAll("[data-pdp-variant-sku]").forEach((sku) => {
      sku.textContent = displaySku(variant);
    });
  };

  productForm.addEventListener("change", (event) => {
    if (!event.target.classList.contains("js-variant-change")) return;
    requestAnimationFrame(sync);
  });

  sync();
})();
